// extracted by mini-css-extract-plugin
module.exports = {"select":"select__5_Bq4"};